const IMAGES = {
    logo: require("../assets/images/logo.png"),
    notFound: require("../assets/images/not_found.webp"),
    onBoarding1: require("../assets/images/on-boarding-1.webp"),
    onBoarding2: require("../assets/images/on-boarding-2.webp"),
    dashboardLogo: require("../assets/images/dashboard-logo.png"),
    statues: require("../assets/images/statues.webp"),
    avatar1: require("../assets/images/avatar-1.webp"),
    chatBg: require("../assets/images/chat-bg.webp"),
    communityPlaceHolder: require("../assets/images/community_placeholder.webp"),
    logoBlack: require("../assets/images/logo-black.png"),
    comingSoon1: require("../assets/images/coming-soon-1.webp"),
    comingSoon2: require("../assets/images/coming-soon-2.webp"),
    comingSoon3: require("../assets/images/coming-soon-3.webp"),
    comingSoon4: require("../assets/images/coming-soon-4.webp"),
    myCommunity: require("../assets/images/my-community.webp"),
    yourProducts: require("../assets/images/your-products.webp"),
    courses: require("../assets/images/courses.webp"),
    sfx: require("../assets/images/sfx.webp"),
    luts: require("../assets/images/luts.webp"),
    presets: require("../assets/images/presets.webp"),
    eBooks: require("../assets/images/e-books.webp"),
    eGuides: require("../assets/images/e-guides.webp"),
    zylenIntro: require("../assets/images/zylen-intro.webp"),
    noInternet: require("../assets/images/no-internet.webp"),
    error500: require("../assets/images/error-500.webp"),
    videoPlaceHolder: require("../assets/images/video-placeHolder.webp"),
};

export { IMAGES };
